import { render } from "./SublinkNaveMobi.vue?vue&type=template&id=cd5849da&scoped=true"
import script from "./SublinkNaveMobi.vue?vue&type=script&lang=js"
export * from "./SublinkNaveMobi.vue?vue&type=script&lang=js"

import "./SublinkNaveMobi.vue?vue&type=style&index=0&id=cd5849da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5849da"]])

export default __exports__